import { ACCELERATOR_ROLES, PARTNER_ROLES } from '../lib';
export * from './tiptap';

export const propToObjKeyOrEmpty = (prop: unknown, keyName: string) =>
  prop ? { [keyName]: prop } : {};

type UserPayload =
  | {
      _account_roles: string[];
    }
  | {
      accountRoles: string[];
    };

/**
 * Determines if a user is an accelerator user.
 * @param accessTokenPayload The access token payload object.
 * @returns True if the user is an accelerator user, false otherwise.
 */
export const isAcceleratorUserFromSession = (
  accessTokenPayload: UserPayload,
) => {
  let accountRoles: string[] = [];
  if ('_account_roles' in accessTokenPayload) {
    accountRoles = accessTokenPayload._account_roles;
  } else if ('accountRoles' in accessTokenPayload) {
    accountRoles = accessTokenPayload.accountRoles;
  }
  return ACCELERATOR_ROLES.some((role) => accountRoles.includes(role));
};

/**
 * Determines if a user is a partner user.
 * @param accessTokenPayload The access token payload object.
 * @returns True if the user is a partner user, false otherwise.
 */
export const isPartnerUserFromSession = (accessTokenPayload: UserPayload) => {
  let accountRoles: string[] = [];
  if ('_account_roles' in accessTokenPayload) {
    accountRoles = accessTokenPayload._account_roles;
  } else if ('accountRoles' in accessTokenPayload) {
    accountRoles = accessTokenPayload.accountRoles;
  }
  return PARTNER_ROLES.some((role) => accountRoles.includes(role));
};

export function slugify(value: string) {
  return value.toLowerCase().replace(/ /g, '-');
}

/**
 * Returns the ordinal suffix for a given number
 * @param n The number to get the suffix for
 * @returns The suffix
 */
export function getOrdinalSuffix(n: number): string {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return s[(v - 20) % 10] || s[v] || s[0];
}

/**
 * Returns the Twitter social card share URL for a given username
 * @param username The username to get the share URL for
 * @returns The Twitter share URL
 */
export function getBreakoutTwitterShareUrl(baseUrl: string, username: string) {
  const shareableUrl = new URL(`/hackathon/social-card/${username}`, baseUrl);
  const twitterPostText = encodeURIComponent(
    `I'm building in the Solana Breakout Hackathon, powered by @Colosseum!\n\n${shareableUrl.toString()}`,
  );
  return `https://twitter.com/intent/tweet?text=${twitterPostText}`;
}
